import React from 'react';
import { useHistory } from 'react-router-dom';
import { ChartView } from './chartFragments';
import { NoItemsYet } from 'components';
import { Images } from 'utils';

export const Charts = () => {
  const history = useHistory();
  const info = history?.location?.state;

  return (
    <div className='chard-wrapper'>
      {info?.activeChart ?
        <ChartView />
        :
        <NoItemsYet
          title={'No Selected a KPI Widget'}
          description={'Click on a KPI widget from the top to view detailed data.'}
          image={Images.emptyWidget}
          stylesWrapper={{
            height: '56vh',
          }}
          stylesBox={{
            maxWidth: 446,
            padding: '32px',
          }}
        />
      }
    </div>
  );
};